import { SortDescriptor } from "react-aria-components";

import { USED_BY_COLUMN_ID } from "../constants";
import { EntityWithRoleBinding } from "../types";

export const sortEntities = (items: EntityWithRoleBinding[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as USED_BY_COLUMN_ID) {
      case USED_BY_COLUMN_ID.TYPE:
        valueA = a.type;
        valueB = b.type;
        break;
      case USED_BY_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case USED_BY_COLUMN_ID.SPACE:
        valueA = a.space.name;
        valueB = b.space.name;
        break;
      case USED_BY_COLUMN_ID.DELETE_ACTION:
        valueA = "";
        valueB = "";
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};
